import { PurchaseFilterValues } from "./PurchaseFilterValues";

export const buildPurchaseFilterPayload = (
  filters: PurchaseFilterValues
): Record<string, any> => {
  const payload: Record<string, any> = {};

  if (filters.documentType) payload.documentTypeId = filters.documentType;
  if (filters.documentNumber) payload.documentNumber = filters.documentNumber;
  if (filters.supplierId) payload.supplierId = filters.supplierId;
  if (filters.documentDate) payload.purchaseDate = filters.documentDate;
  if (filters.total) payload.total = filters.total;

  return payload;
};
